var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRetweet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5381 11.7674H11.8578V4.87525C11.8578 4.64551 11.7217 4.49235 11.5176 4.49235H5.73438V3.72656H11.5176C12.0959 3.72656 12.5381 4.22433 12.5381 4.87525V11.7674Z",
    fill: "#506473"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1493 12.3855L9.90078 9.46841L10.4298 8.94482L12.1493 11.2636L13.8687 8.94482L14.3977 9.46841L12.1493 12.3855ZM10.496 12.1985H4.87479C4.31267 12.1985 3.88281 11.7124 3.88281 11.0766V4.34473H4.54413V11.0766C4.54413 11.301 4.67639 11.4506 4.87479 11.4506H10.496V12.1985Z",
    fill: "#506473"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.84374 6.81918L4.18827 4.73503L2.53281 6.81918L2.02344 6.34857L4.18827 3.72656L6.35311 6.34857L5.84374 6.81918Z",
    fill: "#506473"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetweet);
export default __webpack_public_path__ + "static/media/Retweet.5b2d8f571631990f4301da71545a7b96.svg";
export { ForwardRef as ReactComponent };